import React, { FC } from "react";
import CartesBancairesSVG from "./cartes-bancaires.svg";

type Props = JSX.IntrinsicAttributes;

export const CartesBancairesIcon: FC<Props> = (props) => {
  return <CartesBancairesSVG {...props} />;
};
